import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import HelpDrawer from './HelpDrawer';
import './PageHeader.css';

interface PageHeaderProps {
  title: string;
  helpKey?: string;
  action?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, helpKey, action }) => {
  const { t } = useTranslation();
  const [helpOpen, setHelpOpen] = useState(false);

  const handleOpenHelp = useCallback(() => setHelpOpen(true), []);
  const handleCloseHelp = useCallback(() => setHelpOpen(false), []);

  return (
    <>
      <div className="page-header">
        <div className="page-header__title-group">
          <h2 className="page-header__title">{title}</h2>
          {helpKey && (
            <button
              className="page-header__help-btn"
              onClick={handleOpenHelp}
              aria-label={t('helpButton.ariaLabel')}
              title={t('helpButton.ariaLabel')}
            >
              ?
            </button>
          )}
        </div>
        {action && <div className="page-header__action">{action}</div>}
      </div>

      {helpKey && (
        <HelpDrawer helpKey={helpKey} isOpen={helpOpen} onClose={handleCloseHelp} />
      )}
    </>
  );
};

export default PageHeader;
